import { CognitoUserPool } from 'amazon-cognito-identity-js';

const poolData = {
//  UserPoolId: 'us-east-1_YumM9OhA5',
//ClientId: '6m9ahv4bc4snmkbfavhq9lj8sd',
  UserPoolId: 'us-east-1_i6zi1veFr',
  ClientId: '248jqlfoavh9khdt652qv5n28i',
};

export default new CognitoUserPool(poolData);